// Turnier-Status als EIN Ablauf (18.10.2026): dieselben Werte wie
// backend/utils/turnierStatus.js. Gespeichert heißt „Anmeldung offen“ 'Aktiv'
// (Dojosoftware zählt so); angezeigt wird immer der Klartext.
// Sichtbarkeit (veroeffentlicht) ist aus dem Status abgeleitet und wird nie
// von der Oberfläche gesetzt. Gewechselt wird nur über statusWechseln().
export const TURNIER_STATUS = Object.freeze({
  ENTWURF: 'Entwurf',
  AKTIV: 'Aktiv',
  ANMELDUNG_GESCHLOSSEN: 'anmeldung_geschlossen',
  LAUFEND: 'Laufend',
  ABGESCHLOSSEN: 'Abgeschlossen',
  ABGESAGT: 'Abgesagt',
});

export const ABLAUF = Object.freeze([
  TURNIER_STATUS.ENTWURF, TURNIER_STATUS.AKTIV, TURNIER_STATUS.ANMELDUNG_GESCHLOSSEN,
  TURNIER_STATUS.LAUFEND, TURNIER_STATUS.ABGESCHLOSSEN,
]);

export const STATUS_TEXT = Object.freeze({
  [TURNIER_STATUS.ENTWURF]: 'Entwurf',
  [TURNIER_STATUS.AKTIV]: 'Anmeldung offen',
  [TURNIER_STATUS.ANMELDUNG_GESCHLOSSEN]: 'Anmeldung geschlossen',
  [TURNIER_STATUS.LAUFEND]: 'Läuft',
  [TURNIER_STATUS.ABGESCHLOSSEN]: 'Abgeschlossen',
  [TURNIER_STATUS.ABGESAGT]: 'Abgesagt',
});

/** Klartext zu einem gespeicherten oder wirksamen Status. */
export function statusText(status) {
  return STATUS_TEXT[status] || status || 'unbekannt';
}

/**
 * Status wechseln über PATCH /api/turniere/:id/status (Server prüft Übergang
 * und Vorbereitungsstand). Wirft nicht: liefert { ok, data } oder
 * { ok: false, error, fehlend }.
 */
export async function statusWechseln(turnierId, ziel) {
  try {
    const r = await fetch(`/api/turniere/${turnierId}/status`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: ziel }),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d.success) {
      return { ok: false, error: d.error || `Fehler ${r.status}`, fehlend: d.fehlend || [], code: d.code };
    }
    return { ok: true, data: d.data };
  } catch (e) {
    return { ok: false, error: e.message, fehlend: [] };
  }
}
